import {
  Button,
  Flex,
  Input,
  InputGroup,
  InputLeftAddon,
} from '@chakra-ui/react'

export function Login({ submitForm, register }) {
  return (
    <Flex gap={2} flexDir="column" as="form" onSubmit={submitForm}>
      <InputGroup maxW="300px">
        <InputLeftAddon
          children="Nome"
          bgColor="#95c620"
          borderColor="#95c620"
        />
        <Input
          type="text"
          placeholder="Nome liberador"
          color="gray.700"
          borderColor="#95c620"
          {...register('nome')}
        />
      </InputGroup>
      <InputGroup maxW="300px">
        <InputLeftAddon
          children="Senha"
          bgColor="#95c620"
          borderColor="#95c620"
        />
        <Input
          type="password"
          placeholder="Senha liberador"
          color="gray.700"
          borderColor="#95c620"
          {...register('senha')}
        />
      </InputGroup>
      <Button
        bgColor="#95c620"
        _hover={{ bgColor: '#95c620' }}
        loadingText="Verificando..."
        type="submit"
      >
        Confirmar
      </Button>
    </Flex>
  )
}
